import React from 'react';
import ServiceComponent from './ServiceComponent';
import {Helmet} from 'react-helmet'
export default function BrandingComponent() {

    const description = `Creamos marcas con ADN, entendemos que la identidad de la marca es lo más importante. 
    Gestionamos la marca para crear una conexión positiva con el Target.`

  return (
    <>
      <Helmet>
        <title>Servicios de Branding | Blue Group Marketing | Bolivia</title>
        <meta
          name="description"
          content="Creamos marcas con ADN e identidad propia. Servicios de Naming, concepto de marca, diseño de identidad corporativa y gestión de marca en Bolivia."
        />
        <meta name="keywords" content="branding, diseño de marca, naming, identidad corporativa, imagen de marca, cochabamba, bolivia" />
        <meta name="robots" content="index, follow"/>
        <meta name="googlebot" content="index, follow"/>
        <link rel="canonical" href={`${process.env.FRONTENDURL}BrandingServices`} />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="article" />
        <meta property="og:site_name" content="Blue Group Marketing" />
        <meta property="og:url" content={`${process.env.FRONTENDURL}BrandingServices`} />
        <meta property="og:title" content="Servicios de Branding | Blue Group Marketing | Bolivia" />
        <meta property="og:description" content="Creamos marcas con ADN e identidad propia. Servicios de Naming, concepto de marca, diseño de identidad corporativa y gestión de marca en Bolivia." />
        <meta property="og:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />

        {/* Twitter Cards */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Servicios de Branding | Blue Group Marketing | Bolivia" />
        <meta name="twitter:description" content="Creamos marcas con ADN e identidad propia. Servicios de Naming, concepto de marca, diseño de identidad corporativa y gestión de marca en Bolivia." />
        <meta name="twitter:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />
      </Helmet>
    <ServiceComponent description={description} service="BRANDING" type="Branding">
      <div className="max-w-7xl mx-auto">
        <ul className="text-3xl italic font-bold mt-20 text-center sm:text-left">
          <li className="text-bluegroup-300 mb-10"><img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Naming y Creación de Nombre" src={require('../../assests/OurServices/Branding/naming_icon.png')}/>Naming / Creación de nombre</li>
          <li className="text-bluegroup-800 mb-10"><img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Concepto de marca" src={require('../../assests/OurServices/Branding/concepto_icon.png')}/>Concepto de marca</li>
          <li className="text-bluegroup-100 mb-10"><img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Identidad de marca" src={require('../../assests/OurServices/Branding/identidad_icon.png')}/>Identidad de marca</li>
          <li className="text-bluegroup-200 mb-10"><img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Manejo y gestión de marca" src={require('../../assests/OurServices/Branding/manejo_icon.png')}/>Manejo de marca</li>
        </ul>
      </div>
    </ServiceComponent>
    </>
  );
}